module.exports = __webpack_public_path__ + "static/media/uisce.baec65ab.png";